import React, { Component } from 'react';
import './questions.css';
import skill from "../static/self2-image.png";
import job from "../static/self3-image.png";
import trueImage from "../static/true.png";
import falseImage from "../static/false.png";

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {Button} from 'antd';

import Translate from "../translate/Translate";
import {
    questionsList,
    questionsSubmit
} from '../../modules/questions';

class TrueFalse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questionData: null,
            loading: false,
            answers: ["", "", "", "", "", "", ""],
        }
    }
    componentDidMount() {
        if (!this.props.questionsData) {
            this.getQuestions();
            // console.log(this.props.questionsData)
        }
        if (this.props.questionsData) {
            if (this.props.questionsData.progress == "competencies") {
                // this.getskillData();
            }
            else {
                if (this.props.questionsData.progress == "occupations") {
                    // this.getjobData();
                }
                else {
                    this.props.formSubmit();
                }
            }
        }

    }

    // componentDidMount for API
    componentWillMount() {
        if (this.props.questionsData.progress == "competencies") {
            // this.getskillData();
        }
        else {
            if (this.props.questionsData.progress == "occupations") {
                // this.getjobData();
            }
            else {
                this.props.formSubmit();
            }
        }

    }

    // getskillData() {
    //     this.setState({
    //         questionData: {
    //             trad: {
    //                 title: "技能",
    //                 question: ["請在你能夠做得好的活動旁選擇", "，從未做過或做得不好的活動旁選擇", "。"],
    //             }
    //         }
    //     })
    // }

    // getjobData() {
    //     this.setState({
    //         questionData: {
    //             trad: {
    //                 title: "職業",
    //                 question: ["以工作內容作考量，請在你感興趣或吸引你的職業旁選擇", "，在你不喜歡或不感興趣的職業旁選擇", "。"],
    //             }
    //         }
    //     })
    // }

    radioOnChange(number, status) {
        this.setState(state => {
            const answers = state.answers.map(
                (value, i) => {
                    // console.log(number, i,status,value)
                    if (number == i) {
                        return status
                    }
                    else {
                        return value
                    }
                }
            );
            return { answers };
        })
        // console.log(this.state.answers)
    }

    actFormSubmit = (event) => {
        this.setState({ loading: true });
        event.preventDefault();
        // console.log('Received values of form: ', this.state.answers);
        let resultData = {
            "category": this.props.questionsData.progress,
            "lastQuestionNumber": this.props.questionsData.questions[6].questionNumber,
            "result": {
                "R": 0,
                "I": 0,
                "A": 0,
                "S": 0,
                "E": 0,
                "C": 0,
            }
        }
        this.props.questionsData.questions.map((object, index) => {
            if (this.state.answers[index]) {
                resultData.result[object.group] += 1;
                this.state.answers[index] = "";
            }
            else {
                this.state.answers[index] = "";
            }
        });

        this.props.questionsSubmit(resultData).then(
            (res) => {
                if (res) {
                    console.log("success")
                    this.setState({ loading: false, errormessage: null });
                    this.props.formSubmit();
                } else {

                    this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
                }
            },
            (err) => {
                console.log("error")
                this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
                // this.formRef.current.resetFields();
            }
        );
        // this.props.formSubmit();
    }

    render() {

        const data = {
            trad: {
                submit: "下一步"
            }
        };

        const { questionData, loading } = this.state;

        // console.log(this.state.selectedRadio);
        // console.log(this.props.mode);

        return (
            <div className="formContainer">
                <div className={(this.props.questionsData.progress == "competencies") ? "questionImageContainer skillBgColor" : "questionImageContainer jobBgColor"}>
                    <img src={(this.props.questionsData.progress == "competencies") ? skill : job} className="questionImage"></img>
                    <h1><Translate id={`questions.${this.props.questionsData.progress}.title`} /></h1>
                </div>
                <div className="questionFormContainer">
                    <form onSubmit={this.actFormSubmit} name="questionsForm">
                        <div className="form lightFont">
                            <div className="radioTitle">
                                <Translate id={`questions.${this.props.questionsData.progress}.description1`} /><img src={trueImage} className="truefalseTitleImage" />
                                <Translate id={`questions.${this.props.questionsData.progress}.description2`} /><img src={falseImage} className="truefalseTitleImage" />
                            </div>
                            <br></br>

                            {(this.props.questionsData) ?
                                this.props.questionsData.questions.map((item, index) =>
                                    <div key={index} className="formItem2 darkFont questionsContainer">
                                        <div className="radioLabel">{item["question_" + this.props.language]}</div>
                                        <div className="radioItem">
                                            <input type="radio" name={item.questionNumber + "radio"} id={item.questionNumber + "true"} value="1" onChange={this.radioOnChange.bind(this, index, true)} checked={this.state.answers[index]} />
                                            <label htmlFor={item.questionNumber + "true"}>
                                                <img src={trueImage} className="truefalseImage" />
                                            </label>
                                            <input type="radio" name={item.questionNumber + "radio"} id={item.questionNumber + "false"} value="0" onChange={this.radioOnChange.bind(this, index, false)} checked={(this.state.answers[index] === false) ? true : false} required />
                                            <label htmlFor={item.questionNumber + "false"} >
                                                <img src={falseImage} className="truefalseImage" />
                                            </label>
                                        </div>
                                    </div>
                                )
                                : null}


                            <div className="submitBtnContainer">
                                <Button htmlType="submit" className="radioSubmitBtn" ><Translate id = "questions.next" /></Button>
                            </div>
                        </div>
                    </form>
                </div>
                {
                  (!this.props.questionsData || loading) &&
                  <div className="loading-screen">
                    <div className="loading-container">
                      <div className="loading-dot class7" />
                      <div className="loading-dot class8" />
                      <div className="loading-dot class9" />
                    </div>
                  </div>
                }
            </div>
        )
    }
}


const mapStateToProps = state => ({
    questionsData: state.questions.questionsData,
    language: state.mainpage.language
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            questionsList,
            questionsSubmit
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TrueFalse);